module.exports = __webpack_public_path__ + "static/img/9.4c2ee2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9.png
// module id = rqk2
// module chunks = 1